import { useAppSelector } from "../redux/store";
import {
  selectPlayerData,
  selectGameStatus,
  selectPlayers,
  selectCountdown,
  selectPlayerStatus,
  selectPlayer,
  selectLoading,
} from "../redux/selectors";
import { GameStatus } from "../types/game-status";
import { Player } from "../types";

interface UseWaitableDataProps {
  waitingFor: GameStatus[];
  audienceOverride?: boolean;
}

export const useWaitableData = ({
  waitingFor,
  audienceOverride,
}: UseWaitableDataProps) => {
  // Use narrow selectors instead of entire slices to reduce re-renders
  const gameStatus = useAppSelector(selectGameStatus);
  const gamePlayers = useAppSelector(selectPlayers);
  const gameCountdown = useAppSelector(selectCountdown);
  const playerStatus = useAppSelector(selectPlayerStatus);
  const player = useAppSelector(selectPlayer);
  const playerData = useAppSelector(selectPlayerData);
  const loading = useAppSelector(selectLoading);

  function _audienceWait() {
    return playerData.audience && !audienceOverride;
  }

  function _statusWait() {
    return player && waitingFor.includes(playerStatus);
  }

  function shouldWait() {
    return _audienceWait() || _statusWait();
  }

  function getSkippyText() {
    if (
      gameStatus === GameStatus.GameStatusLobby ||
      gameStatus === GameStatus.GameStatusQuickStart ||
      gameStatus === GameStatus.GameStatusCharacters ||
      gameStatus === GameStatus.GameStatusStoryCreate
    ) {
      return "you can kick players by clicking on them and clicking kick.";
    } else if (
      gameStatus === GameStatus.GameStatusStoryTitle ||
      gameStatus === GameStatus.GameStatusVoting
    ) {
      return "you can skip players by selecting them and then clicking skip.";
    }
  }

  function filterWaitingPlayers(p: Player) {
    return !waitingFor.includes(p.status_str) && p.id !== player?.id;
  }

  const waitingPlayers = gamePlayers.filter(filterWaitingPlayers);

  return {
    shouldWait: shouldWait(),
    skippyText: getSkippyText(),
    waitingPlayers,
    loading,
    countdown: gameCountdown,
  };
};

